import React from 'react';
import { ChevronUp } from 'lucide-react';

interface ScrollToTopProps {
  /** Supplied by the shared scroll hook so we don't register a second listener. */
  scrollY: number;
}

const ScrollToTop: React.FC<ScrollToTopProps> = ({ scrollY }) => {
  const isVisible = scrollY > 500;

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      onClick={scrollToTop}
      aria-label="Scroll to top"
      aria-hidden={!isVisible}
      tabIndex={isVisible ? 0 : -1}
      className={`fixed bottom-6 left-6 z-50 w-11 h-11 rounded-full flex items-center justify-center border border-dark-border bg-dark-surface/80 backdrop-blur text-dark-muted transition-all duration-300 ease-out-soft hover:text-accent hover:border-accent/40 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-dark-bg ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3 pointer-events-none'
      }`}
    >
      <ChevronUp size={20} />
    </button>
  );
};

export default ScrollToTop;
